<template src="./RegisteredAgents.html" />

<script>
import { computed } from 'vue'
import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"
import Agent from "../Agent/Agent.vue"
import MultiplierCard from './components/MultiplierCard'

export default {
  name: "RegisteredAgents",
  mixins: [mixins],
  components: {
    Agent,
    MultiplierCard
  },
  data() {
    return {      
      aasList: [],
      aasId: null,
      aasCurrent: 1,
      aasPages: 0,
      aasPagination: false,

      indicatedList: [],
      indicatedListPaginated: [],
      indicatedCurrent: 1,
      indicatedPages: 0,
      indicatedPagination: false,

      multiplierCardList: [],
      multiplierName: null,
      multiplierId: null,
      multiplierSelected: null,
      
      showTableAAS: true,
      showModalIndicated: false,
      showModalMultiplier: false,
      search: ""
    };
  },
  setup () {
    const store = useStore()

    return {
      filooUrlServer: computed(() => store.state.filooServer),
      isDesktop: computed(() => store.getters.isDesktop),
      isMobile: computed(() => store.getters.isMobile),
    }
  },
  mounted: function () {
    this.getAAS()
  },
  watch: {
    aasCurrent: function () {
      this.getAAS()
    },
    indicatedCurrent: function () {
      this.setIndicatedPagination()
    },
  },
  methods: {
    getAAS() {
      const page = this.aasCurrent - 1

      this.axios.get(
        `${this.filooUrlServer}aas/users?page=${page}&size=10&search=${this.search}`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.aasPages = data.totalPages
            this.aasPagination = this.aasPages > 1

            this.aasList = data.content.map((aas) => ({
              ...aas,
              name: aas.user ? aas.user.name : 'Sem registro',
              city: aas.address ? aas.address.city : 'Sem registro',
              state: aas.address ? aas.address.state : 'Sem registro'
            }))
          }
        })
    },
    clickShowAASTable () {
      this.showTableAAS = true
      this.getAAS()
    },
    editAAS(id){
      if (id) {
        this.aasId = id
        this.showTableAAS = false
      }
    },
    getIndicatedList (id) {
      this.showModalIndicated = false
      this.axios.get(
        `${this.filooUrlServer}aas/indicates/${id}`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.indicatedList = data
            this.indicatedPages = Math.ceil(this.indicatedList / 3)
            this.indicatedPagination = this.indicatedPages > 1
            this.setIndicatedPagination()
            this.showModalIndicated = true
          }
        })
        .catch(() => {
          this.showModalIndicated = false
          this.$swal(
            "Atenção!",
            "Não foi possível listar os clientes indicados. Por favor contacte o administrador do sistema",
            "error"
          );
        });
    },
    setIndicatedPagination(){
      const sliceStart = (this.indicatedCurrent - 1) * 3
      const sliceEnd = this.indicatedCurrent * 3

      this.indicatedListPaginated = this.indicatedList.slice(sliceStart, sliceEnd)
    },
    async getMultiplier(id) {
      await this.axios.get(
        `${this.filooUrlServer}aas/user/qrcode/${id}`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ data, status }) => {
          if (status === 200) {
            if (data.plans.length) {
              this.multiplierId = id
              this.multiplierName = data.name
              this.multiplierSelected = data.plans[0]
  
              this.multiplierCardList = data.plans.map((card) => {
                return {
                  value: card,
                  text: `${card.layout.toUpperCase()} - ${card.name}`
                }
              })
  
              this.showModalMultiplier = true
            } else {
              this.$swal(
                "Atenção",
                "Este multiplicador não tem planos vinculados",
                "warn"
              )
            }
          }
        }) 
        .catch(() => {
          this.$swal(
            "Atenção!",
            "Não foi possível listar os dados deste colaborador",
            "error"
          );
        })
    },
    handleSearch(search) {
      this.search = search

      if (this.aasCurrent === 1) {
        this.getAAS()
      } else {
        this.aasCurrent = 1
      }        
    },
  },
};
</script>

<style lang="scss" src="./RegisteredAgents.scss" />
